import { memo, useMemo } from "react";
import {
  approximatelyIncludes,
  normalizeApproximateText,
} from "@tribunalea/shared";

function matchingRanges(value, patterns) {
  const text = String(value || "");
  const tokens = [
    ...text.matchAll(/\bp\s*\/|[\p{L}\p{N}]+/giu),
  ].map((match) => ({
    value: match[0],
    start: match.index,
    end: match.index + match[0].length,
  }));
  const ranges = [];

  patterns.filter(Boolean).forEach((pattern) => {
    const patternTokenCount = normalizeApproximateText(pattern)
      .split(" ")
      .filter(Boolean).length;
    if (!patternTokenCount) return;
    for (
      let start = 0;
      start <= tokens.length - patternTokenCount;
      start += 1
    ) {
      const windowTokens = tokens.slice(start, start + patternTokenCount);
      const candidate = windowTokens.map(({ value: token }) => token).join(" ");
      const candidateNormalized = normalizeApproximateText(candidate);
      const patternNormalized = normalizeApproximateText(pattern);
      if (
        approximatelyIncludes(candidate, pattern) ||
        candidateNormalized.includes(patternNormalized)
      ) {
        ranges.push({
          start: windowTokens[0].start,
          end: windowTokens.at(-1).end,
        });
      }
    }
  });

  return ranges
    .sort((left, right) => left.start - right.start || left.end - right.end)
    .reduce((merged, range) => {
      const previous = merged.at(-1);
      if (previous && range.start <= previous.end) {
        previous.end = Math.max(previous.end, range.end);
      } else {
        merged.push({ ...range });
      }
      return merged;
    }, []);
}

export const ApproximateMatchText = memo(function ApproximateMatchText({
  value,
  patterns,
}) {
  const text = String(value || "");
  const ranges = useMemo(
    () => matchingRanges(text, patterns),
    [text, patterns],
  );
  if (!ranges.length) return text;
  const parts = [];
  let cursor = 0;
  ranges.forEach((range, index) => {
    if (range.start > cursor) parts.push(text.slice(cursor, range.start));
    parts.push(
      <mark className="daily-list-match" key={`${range.start}:${index}`}>
        {text.slice(range.start, range.end)}
      </mark>,
    );
    cursor = range.end;
  });
  if (cursor < text.length) parts.push(text.slice(cursor));
  return parts;
});
